import getEntryPersistentStorage, {EntryStoragePropertyEnums} from 'notebook/notes/EntryPersistentStorage';
import {NoteDay, NotePart} from 'notebook/util/NoteUtilConstants';

export default function getUncollapsedNoteParts(
  noteParts: Array<NotePart>,
  fileSectionState: {[puuid: string]: {[property: string]: boolean}},
  noteDays: Array<NoteDay>
): Array<NotePart> {
  const openSections = noteDays
    .map((day, index) => ({
      index,
      start: day.index,
      end: index < noteDays.length - 1 ? noteDays[index + 1].index : noteParts.length,
      provenanceUuid: day.provenanceUuid,
    }))
    .filter(({provenanceUuid}) =>
      // returns only the days that are open, or all days if PUUID is not in fileSectionState
      getEntryPersistentStorage().getPropertyValueFromPUUID(
        fileSectionState,
        provenanceUuid,
        EntryStoragePropertyEnums.IS_OPEN
      )
    );
  return openSections.reduce((openItems, {start, end}) => [...openItems, ...noteParts.slice(start, end)], []);
}
